<template>
    <header class="layout-header header">
        <div class="layout-header-inner">
            <!--用户简介-->
            <div class="header-profile">
                <avatar :url="profile.avatar"
                        :size="64"
                        class="header-profile-avatar">
                </avatar>
                <div class="header-profile-user">
                    <div class="header-profile-name">
                        <span>{{ profile.name || '' }}</span>
                        <i class="icon-down-dir-1"></i>
                    </div>
                    <div class="header-profile-menu">
                        <ul>
                            <li>
                                <a href="javascript:void(0)" @click="showPosters">
                                    <i class="el-icon-picture-outline"></i>
                                    <span>专属海报</span>
                                </a>
                            </li>
                            <li>
                                <router-link to="/user/info/basic">
                                    <i class="icon-iconfont-yonghu"></i>
                                    <span>个人中心</span>
                                </router-link>
                            </li>
                            <li @click="logout">
                                <a href="javascript:void(0)">
                                    <i class="icon-logout"></i>
                                    <span>退出</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!--导航跳转-->
            <nav class="header-nav">
                <router-link :to="{name: 'index@index'}" class="header-nav-logo"></router-link>
                <router-link :to="{name: 'index@index'}" :class="['header-nav-item', isIndex ? 'active': '']">首页</router-link>
                <router-link :to="{name: 'schedule@course'}" :class="['header-nav-item', isMyCourse ? 'active': '']">我的课程</router-link>
                <router-link :to="{name: 'templateLesson@resource'}" :class="['header-nav-item', isResourse ? 'active': '']">我的资源</router-link>
                <router-link :to="{name: 'LearningcenterList@learning'}" :class="['header-nav-item', isLearning ? 'active': '']">学习中心</router-link>
                <router-link :to="{name: 'teachingPlan@teachingPlan'}" :class="['header-nav-item', isTeachingPlan ? 'active': '']">教学规划</router-link>
                <router-link :to="{name: 'messageCenter'}" :target="$route.name.includes('messageCenter') ? '' : '_blank'" :class="['header-nav-item', $route.name === 'messageCenter'?
                'active': '']" style="float: right;margin-right: 10px;font-size:12px;color:#fff;">
                    <el-badge :value="unReadLen" :max="99" class="item">
                        <div class="message-enter"><i class="el-icon-message"></i></div>
                    </el-badge>
                </router-link>
                <router-link :to="{name: 'download'}" :class="['header-nav-item', $route.name === 'download'?
                'active': '']" style="float: right;margin-right: 10px;font-size:12px;color:#fff;"><i class="download"></i>客户端下载</router-link>
            </nav>
            <!-- 消息弹窗 -->
            <message-popup v-if="showMessagePopup"></message-popup>
            <el-dialog
                class="posters"
                title="我的专属海报"
                :visible.sync="postersModel"
                :append-to-body="true">
                <posters></posters>
            </el-dialog>
        </div>
    </header>
</template>
<script>
import Avatar from './AppAvatar.vue';
import MessagePopup from './MessagePopup.vue';
import posters from './posters.vue';
import { mapState, mapActions } from 'vuex';
import baseAppMixin from '../../mixin/baseAppMixin';
export default {
    components: {
        Avatar,
        MessagePopup,
        posters
    },
    mixins: [baseAppMixin],
    data() {
        return {
            postersModel: false
        };
    },
    computed: {
        ...mapState({
            profile: state => state.user.profile,
            messageList: state => state.message.allMessageList
        }),
        isMyCourse() {
            let name = this.$route.name;
            if (name && (name.indexOf('@course') > -1 || name.indexOf('@student') > -1)) {
                return true;
            }
            return false;
        },
        isResourse() {
            let name = this.$route.name;
            if (name && (name.indexOf('@resource') > -1)) {
                return true;
            }
            return false;
        },
        isMyTeam() {
            let name = this.$route.name;
            if (name && (name.indexOf('myTeam') > -1)) {
                return true;
            }
            return false;
        },
        isLearning() {
            let name = this.$route.name;
            if (name && (name.indexOf('@learning') > -1)) {
                return true;
            }
            return false;
        },
        isIndex() {
            let name = this.$route.name;
            if (name && (name.indexOf('@index') > -1)) {
                return true;
            }
            return false;
        },
        isTeachingPlan() {
            let name = this.$route.name;
            if (name && (name.indexOf('@teachingPlan') > -1)) {
                return true;
            }
            return false;
        },
        showMessagePopup() {
            return !['messageCenter', 'messageCenter@details'].includes(this.$route.name);
        },
        unReadLen() {
            if (this.messageList && this.messageList.length) {
                return this.messageList.filter(v => !v.read).length;
            }
            return 0;
        }
    },
    methods: {
        ...mapActions(['USER_DELETE_LOGOUT']),
        logout() {
            this.USER_DELETE_LOGOUT().then(() => {
                location.href = '/';
            }).then(() => {
                /* window.sessionStorage.removeItem('mesage_token'); */
            })
            ;
        },
        showPosters() {
            this.postersModel = true;
        }
    }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '~@/assets/styles/base/colorLibrary.scss';

/* 用户简介 */
.header-profile {
    float: right;
}

.header-profile-avatar {
    width: 36px;
    height: 36px;
    vertical-align: middle;
    border-radius: 50%;
}

.header-profile-user {
    position: relative;
    display: inline-block;

    &:hover {
        .header-profile-menu {
            display: block;
        }
    }
}

.header-profile-name {
    text-align: right;
    color: #fff;
    cursor: pointer;

    span {
        margin-left: 10px;
        margin-right: 10px;
    }

    i {
        color: #e1e1e1;
    }
}

.header-profile-menu {
    display: none;
    position: absolute;
    width: 128px;
    top: 50px;
    right: 0;
    padding-top: 10px;
    z-index: 10;

    ul {
        box-shadow: 0 1px 1px rgba(199, 199, 199, 1);
    }

    li {
        width: 128px;
        background: $C01;

        a {
            display: block;
            padding-left: 30px;
            height: 40px;
            line-height: 40px;
            box-sizing: border-box;
            border-bottom: 1px solid $C04;
            font-size: 12px;
            color: $C12;
            text-decoration: none;

            i {
                font-size: 14px;
                color: $C08;
            }

            span {
                margin-left: 6px;
            }

            &:hover {
                background: #fafafa;
                color: $C12;
                text-decoration: none;
            }

            &:last-child {
                border-bottom: 0;
            }
        }
    }
}

/* 导航跳转 */
.header-nav {
    font-size: 14px;
}

.header-nav-logo {
    float: left;
    width: 160px;
    height: 34px;
    margin: 13px 60px 0 0;
    background: url(~@/assets/images/common/tab_logo.png) center no-repeat;
    background-size: contain;
}

.header-nav-item {
    float: left;
    position: relative;
    width: 110px;
    height: 100%;
    text-align: center;
    color: #fff;
    text-decoration: none;
    font-size: 16px;

    &.active {
        background-color: rgba(0,0,0, 0.1);
        text-decoration: none;
    }

    &:hover {
        background-color: rgba(0,0,0, 0.1);
        text-decoration: none;
    }
}

.download {
    background: url('~@/assets/images/common/download_icon_xz_default.png') center;
    width: 15px;
    height: 15px;
    display: inline-block;
    background-size: contain;
    margin-right: 4px;
    margin-bottom: -3px;
}

/* 消息中心入口 */
.item {
    /deep/ .el-badge__content.is-fixed {
        top: 20px;
        height: 20px;
    }

    .message-enter {
        height: 60px;

        /deep/ i {
            font-size: 30px;
            line-height: 60px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/common/AppHeader.vue